/**
 * Activity tab — wraps the shared AccountActivityFeed component.
 */

import React from 'react';
import {Card} from '@common-web/components/ui/card';
import {AccountActivityFeed} from '@common-web/components/account/AccountActivityFeed';

interface ActivityTabProps {
  accountsId: string;
}

export function ActivityTab({accountsId}: ActivityTabProps): React.ReactElement {
  return (
    <Card className='border-border p-6 shadow-sm'>
      <h3 className='mb-5 text-sm font-semibold uppercase tracking-wide text-foreground'>
        Activity
      </h3>
      <AccountActivityFeed accountsId={accountsId} />
    </Card>
  );
}
